/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CompositionProductVariantSummaryDTO } from './compositionProductVariantSummaryDTO';

export interface SubscriberEditionCompositionSummary {
  boxId?: string;
  chaveNFE?: string;
  compositionId?: number;
  compositionName?: string;
  dateCreated?: Date;
  dateCreatedMillenium?: Date;
  dateUpdated?: Date;
  dateUpdatedMillenium?: Date;
  editionId?: number;
  finalDeliveryDate?: Date;
  glamclub?: boolean;
  imageURL?: string;
  invoiceNumber?: number;
  nfse?: string;
  paymentOrderId?: number;
  pedidoV?: string;
  personId?: number;
  personName?: string;
  products?: Array<CompositionProductVariantSummaryDTO>;
  recurrentPaymentId?: number;
  rps?: number;
  shippingOrderId?: number;
  statusMillenium?: string;
  subscriberBillingId?: number;
  subscriberEditionId?: number;
  subscriberEditionStatusId?: number;
  subscriberEditionStatusName?: string;
  subscriberId?: number;
  subscriptionId?: number;
  subscriptionName?: string;
  theme?: string;
  title?: string;
  trackingCode?: string;
}
